module.exports = __webpack_public_path__ + "img/ring_y_i_1_1@3x.6817452d.png";